import { lazy } from 'react';

const CompanyDetailsRoute = lazy(
  () => import('../../company/details/CompanyDetailsRoute')
);

const UserCompanyDetails = () => {
  return <CompanyDetailsRoute />;
};

export default UserCompanyDetails;
